import React from 'react';
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import {connect} from 'react-redux'
import Typography from "@mui/material/Typography";
import {useTranslation} from 'react-i18next';
import Alert from '@mui/material/Alert';
import Button from "../../inputs/Button";
import {productSetSale} from "../../../../store/actions/store/ProductAction";
import MoneyOffIcon from '@mui/icons-material/MoneyOff';


const RemoveFromSaleDialog = ({productId, good, open, setOpen, deleting, unlinkGood, removeFromSale}) => {
    const {t} = useTranslation();

    const handleClose = () => {
        setOpen(false);
    };

    const handleDelete = () => {
        removeFromSale(productId)
            .then(handleClose)
    };

    return (
        <Dialog
            open={open}
            aria-labelledby={t('confirm_delete_product_sale_title')}
            aria-describedby={t('confirm_delete_product_sale_title')}
            fullWidth
        >
            <DialogTitle id="product-deletesale-title">{t('confirm_delete_product_sale_title')}</DialogTitle>
            <DialogContent>
                <DialogContentText id="product-deletesale-desc">
                    <Alert severity='warning'>
                        {t('confirm_delete_product_sale_desc')}
                    </Alert>
                    <br/>
                    <Typography variant="body1" color="textPrimary" component="span">{t('are_you_sure')}</Typography>
                </DialogContentText>
            </DialogContent>

            <DialogActions>
                <Button variant='contained' color="primary" autoFocus onClick={handleClose} disabled={deleting}>
                    {t('back_btn')}
                </Button>
                <Button color="secondary" loading={deleting} disabled={deleting} endIcon={<MoneyOffIcon/>}
                        onClick={handleDelete}>
                    {t('remove_from_sale_btn')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

const mapStateToProps = (state) => {
    return {
        deleting: state.product.changingSaleState
    }
};

const mapDispatchToProps = (dispatch, props) => {
    return {
        removeFromSale: (id) => dispatch(productSetSale(id, false)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(RemoveFromSaleDialog);